var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File/Document--security"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 21.3557H12V22.8557H4.5C4.10253 22.8546 3.72166 22.6962 3.44061 22.4151C3.15955 22.1341 3.00115 21.7532 3 21.3557V3.35573C3.00115 2.95825 3.15955 2.57739 3.44061 2.29633C3.72166 2.01528 4.10253 1.85687 4.5 1.85573H12C12.0986 1.85301 12.1966 1.87173 12.2872 1.91057C12.3778 1.94942 12.459 2.00747 12.525 2.08073L17.775 7.33073C17.8482 7.39676 17.9063 7.4779 17.9451 7.56853C17.984 7.65917 18.0027 7.75715 18 7.85573V11.6057H16.5V9.35573H12C11.6025 9.35458 11.2217 9.19617 10.9406 8.91512C10.6596 8.63406 10.5011 8.2532 10.5 7.85573V3.35573H4.5V21.3557ZM16.2 7.85573L12 3.65573V7.85573H16.2ZM19.5 17.6055C19.5 18.3555 19.275 19.1055 18.9 19.7055L21 21.8055L19.95 22.8555L17.85 20.7555C17.25 21.1305 16.5 21.3555 15.75 21.3555C13.65 21.3555 12 19.7055 12 17.6055C12 15.5055 13.65 13.8555 15.75 13.8555C17.85 13.8555 19.5 15.5055 19.5 17.6055ZM15.75 15.3555C14.475 15.3555 13.5 16.3305 13.5 17.6055C13.5 18.8805 14.475 19.8555 15.75 19.8555C17.025 19.8555 18 18.8805 18 17.6055C18 16.3305 17.025 15.3555 15.75 15.3555Z",
    fill: "#C93030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.4534707d0d48d00950929215615b4c71.svg";
export { ForwardRef as ReactComponent };